import React from "react";
import { useLang } from "@/context/LanguageContext";

export default function Imprint() {
  const { t } = useLang();
  return (
    <div data-testid="imprint-page">
      <section className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
          <h1 className="text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">{t("imprint.title")}</h1>
        </div>
      </section>
      <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
        <div className="space-y-8 text-sm leading-relaxed text-slate-700">
          <div>
            <h2 className="mb-2 text-base font-bold uppercase tracking-wider text-slate-950">{t("imprint.legalTitle")}</h2>
            <p>equi-tec di Daniele Reggi</p>
            <p>via Canaletto 25/3</p>
            <p>48022 Lugo (RA) — Italia</p>
            <p className="mt-2">P.IVA / VAT: 02685120392</p>
            <p>WhatsApp / Tel: +39 334 574 2549</p>
            <p>Email: info@equi-tec.com</p>
          </div>
          <div>
            <h2 className="mb-2 text-base font-bold uppercase tracking-wider text-slate-950">{t("imprint.responsibleTitle")}</h2>
            <p>Daniele Reggi</p>
          </div>
          <div>
            <h2 className="mb-2 text-base font-bold uppercase tracking-wider text-slate-950">{t("imprint.disclaimerTitle")}</h2>
            <p>{t("imprint.disclaimer")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
